import { render, staticRenderFns } from "./management-question-set-detail.vue?vue&type=template&id=54809376&scoped=true&"
import script from "./management-question-set-detail.vue?vue&type=script&lang=js&"
export * from "./management-question-set-detail.vue?vue&type=script&lang=js&"
import style0 from "./management-question-set-detail.vue?vue&type=style&index=0&id=54809376&lang=scss&scoped=true&"
import style1 from "./management-question-set-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54809376",
  null
  
)

export default component.exports